import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg viewBox="0 0 73 59" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><rect x=".5" y=".5" width="72" height="13" rx="6" /><rect x=".5" y="22.5" width="72" height="13" rx="6" /><rect x=".5" y="45.5" width="72" height="13" rx="6" /></svg>);